// extracted by mini-css-extract-plugin
export var bottomCloud = "CtaModule-module--bottomCloud--631de";
export var button = "CtaModule-module--button--f1886";
export var cloudsColorFilterHackWrapper = "CtaModule-module--cloudsColorFilterHackWrapper--9f0cc";
export var content = "CtaModule-module--content--a3bd0";
export var contentContainer = "CtaModule-module--contentContainer--2104b";
export var contentWrapper = "CtaModule-module--contentWrapper--8f5ce";
export var desktop = "CtaModule-module--desktop--8eb30";
export var imageContainer = "CtaModule-module--imageContainer--c54ee";
export var mobile = "CtaModule-module--mobile--65f6a";
export var secondTopCloud = "CtaModule-module--secondTopCloud--624cb";
export var subtitle = "CtaModule-module--subtitle--8dd5a";
export var table = "CtaModule-module--table--c7cf9";
export var tablet = "CtaModule-module--tablet--34fd7";
export var text = "CtaModule-module--text--5fa78";
export var textContainer = "CtaModule-module--textContainer--0e913";
export var title = "CtaModule-module--title--3a8a5";
export var titleAndTextContainer = "CtaModule-module--titleAndTextContainer--d5f32";
export var topCloud = "CtaModule-module--topCloud--e3a13";